import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from "./views/Home";
import About from './views/AboutPage';
import Service from './views/ServicesPage';
import Portfolio from './views/PortfolioPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>

      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/service' element={<Service/>}/>
        <Route path='/portfolio' element={<Portfolio/>}/>
      </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
